import { render, staticRenderFns } from "./GameRound.vue?vue&type=template&id=61276d3c&scoped=true&"
import script from "./GameRound.vue?vue&type=script&lang=js&"
export * from "./GameRound.vue?vue&type=script&lang=js&"
import style0 from "./GameRound.vue?vue&type=style&index=0&id=61276d3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61276d3c",
  null
  
)

export default component.exports